import HomePage from './components/HomePage';
import app from 'flarum/forum/app';
import HeadSlideShow from '../common/models/HeadSlideShow';
import IndexFilter from './IndexFilter';
import PersonMsgFilter from './PersonMsgFilter';
import DiscussionFilter from './DiscussionFilter';
import IndexPage from 'flarum/components/IndexPage';
import CenterIconList from '../common/models/CenterIconList';
import MentionPage from 'flarum/forum/dianLiang/MentionPage';
import ProfilePagePhone from 'flarum/forum/dianLiang/ProfilePagePhone';
import LikePage from 'flarum/forum/dianLiang/LikePage';
import SettingPage from 'flarum/forum/dianLiang/SettingPage';
import SearchView from './components/SearchView';
import UsersSearchView from './components/UsersSearchView';
import addEssenceBadge from '../common/components/addEssenceBadge';
import UserLevel from 'flarum/common/models/UserLevel';
import LevelConf from 'flarum/common/models/LevelConf';
import WikiLabel from 'flarum/common/models/WikiLabel';
import WikiLabelOptions from 'flarum/common/models/WikiLabelOptions';
import WikiLabelOptionsSon from 'flarum/common/models/WikiLabelOptionsSon';
import User from 'flarum/common/models/User';
import Model from 'flarum/common/Model';
import GetRefundedNotification from './components/GetRefundedNotification';
import ChatMuteMemberNotification from './components/ChatMuteMemberNotification';
import ChatReportUserNotification from './components/ChatReportUserNotification';
import UserRoleRewardIsSendedNotification from './components/UserRoleRewardIsSendedNotification';
import UserRoleRewardWaitAcceptNotification from './components/UserRoleRewardWaitAcceptNotification';
import SendNoticeNotification from './components/SendNoticeNotification';
import BeHideNotification from './components/BeHideNotification';
import stormFilter from './stormFilter';
import dawnboundheroFilter from './dawnboundheroFilter';
import epicrouteFilter from './epicrouteFilter';
import HeroTagLatestdata from '../common/models/HeroTagLatestdata';
import HeroTagHeroIntro from '../common/models/HeroTagHeroIntro';
import HeroTagHeroLevel from '../common/models/HeroTagHeroLevel';
export { default as extend } from './extend';

app.initializers.add('flarum-dl-index', () => {
  app.store.models.headSlideShowCategories = HeadSlideShow;
  app.store.models.centerIconCategories = CenterIconList;
  app.store.models.userLevel = UserLevel;
  app.store.models.levelConfList = LevelConf;
  app.store.models.wikiLabelCategories = WikiLabel;
  app.store.models.wikiLabelOptionsCategories = WikiLabelOptions;
  app.store.models.wikiLabelOptionsSonCategories = WikiLabelOptionsSon;

  app.notificationComponents.getRefund = GetRefundedNotification;
  app.notificationComponents.sendNotice = SendNoticeNotification;
  app.notificationComponents.beHide = BeHideNotification;
  app.notificationComponents.chatMuteMember = ChatMuteMemberNotification;
  app.notificationComponents.chatReportUser = ChatReportUserNotification;
  app.notificationComponents.userRoleRewardIsSended = UserRoleRewardIsSendedNotification;
  app.notificationComponents.userRoleRewardWaitAccept = UserRoleRewardWaitAcceptNotification;
  app.store.models.heroTagLatestdataCategories = HeroTagLatestdata;
  app.store.models.heroTagHeroIntroCategories = HeroTagHeroIntro;
  app.store.models.heroTagHeroLevelCategories = HeroTagHeroLevel;

  User.prototype.canBeNotHideChangePwd = Model.attribute('canBeNotHideChangePwd');
  User.prototype.canBeNotHideChangeEmail = Model.attribute('canBeNotHideChangeEmail');
  User.prototype.canLogOut = Model.attribute('canLogOut');

  app.routes['pages.home'] = { path: '/', component: IndexPage };
  if ('ontouchstart' in window && window.innerWidth < 768) {
    app.store.models.type = 'phone';
    app.routes['pages.home'] = { path: '/', component: HomePage };
  }
  app.routes['pkgHome'] = { path: '/pkgId', component: LikePage };
  app.routes['user.mentions2'] = { path: '/user/:username/mentions', component: MentionPage };
  app.routes['user.likes2'] = { path: '/user/:username/likes', component: LikePage };
  app.routes['settings2'] = { path: '/settings', component: SettingPage };
  app.routes['search'] = { path: '/search', component: SearchView };
  app.routes['search.userSearch'] = { path: '/search/userSearch', component: UsersSearchView };
  app.routes['user.ignoredUsers2'] = { path: '/ignoredUsers', component: ProfilePagePhone };
  //首页
  IndexFilter();
  //个人主页
  PersonMsgFilter();
  //讨论
  DiscussionFilter();
  //精华
  addEssenceBadge();

  //风暴
  if (app.data.pkgLogo.ossFile === 'storm') {
    stormFilter();
  }
  //曙光
  if (app.data.pkgLogo.ossFile === 'dawnboundhero') {
    dawnboundheroFilter();
  }
  //海贼
  if (app.data.pkgLogo.ossFile === 'epicroute') {
    epicrouteFilter();
  }

  document.getElementById('app-navigation').addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' }); // 点击按钮返回顶部，平滑滚动效果
  });

  //定义路由
  // app.routes['pages.home'] = {
  //   path: '/pages/home',
  //   component: PagePage,
  // };
});

// Expose compat API
import tagsCompat from './compat';
import { compat } from '@flarum/core/forum';

Object.assign(compat, tagsCompat);
